<template>
      <coreSetups />
</template>
<script>
import coreSetups from "@/components/CompanySetups/coreSetups/coreSetups";
export  default  {
  name: "companyCoreSetup",
  components:{
    coreSetups
  }
}
</script>